// Count of auto-discovered cost sources still awaiting an owner in the Organisation
// dimension. Mirrors DetectedCostSourcesPage's derivation exactly, and shares its
// react-query cache (same query keys) so mounting this hook adds no extra fetch.
import { useQuery } from "@tanstack/react-query";
import { getMatrix } from "../views/allocation/api";
import { getBudgetDimensions } from "../views/cost-allocation/api/costModelApi";

// `organisation` is canonical; `org` is the pre-migration legacy code.
const ORG_DIMENSION_CODES = ["organisation", "org"];

export function countUnassignedDetected(matrix, dimensionsRaw) {
  const orgDim = (dimensionsRaw ?? [])
    .map((d) => ({ id: d.id ?? d.ID, code: (d.code ?? d.Code ?? "").toLowerCase() }))
    .find((d) => ORG_DIMENSION_CODES.includes(d.code));
  const ownerDimensionId = orgDim?.id;
  const detected = (matrix?.sources || []).filter((s) => s.autoDiscovered);
  return detected.filter((s) => !s.cells?.[ownerDimensionId]?.ownerName).length;
}

export function useDetectedSourcesCount() {
  const { data: matrix } = useQuery(["alloc-matrix"], () => getMatrix(), {
    keepPreviousData: true,
  });
  const { data: dimensionsRaw } = useQuery(["budget-dimensions"], getBudgetDimensions);
  return countUnassignedDetected(matrix, dimensionsRaw);
}
